import React, { useState } from 'react';
import "./Infogerance.css";
import AnimatedSection from '../../Hook/Block';
import useCountUp from '../../Hook/useCountUp';
import Flexibilite from './Flexibilite.png';
import Protection from './Protection.png';
import Update from './Update.png';
import TarifsSection from '../../Hook/TarifSection';
import SEO from '../../Hook/Seo';
import BreadcrumbsSchema from '../../Hook/BreadcrumbsSchema';
import VideoPresentationInformatique from '../../pages/Informatique/video_presentation_informatique.mp4';

// ==========================================================================
// DÉCLARATION DES ICÔNES SVG EN DATA URL (Intégrées directement)
// ==========================================================================
const ICON_SHIELD_CHECK = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234c5372' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' /%3E%3C/svg%3E";
const ICON_EYE          = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234c5372' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M15 12a3 3 0 11-6 0 3 3 0 016 0z' /%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z' /%3E%3C/svg%3E";
const ICON_CLOUD        = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234c5372' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z' /%3E%3C/svg%3E";
const ICON_LOCK         = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234c5372' stroke-width='2'%3E%3Crect width='18' height='11' x='3' y='11' rx='2' ry='2'/%3E%3Cpath d='M7 11V7a5 5 0 0 1 10 0v4'/%3E%3C/svg%3E";
const ICON_ALERT        = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234c5372' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z' /%3E%3C/svg%3E";

const Infogerance = () => {
  const clients1 = useCountUp(500, 2000);
  const [openTarifs, setOpenTarifs] = useState({ fixe: false, mobile: false });

  return (
    <>
      <SEO
        title="Maintenance & Infogérance informatique dans les Vosges | AM Services"
        description="Support postes/serveurs, sauvegardes, sécurité, Wi-Fi et réseaux pour PME dans les Vosges."
        path="/infogerance"
        keywords={["maintenance informatique", "infogérance", "support IT", "sécurité informatique"]}
      />
      <BreadcrumbsSchema />

      {/* 1. ACCUEIL PUR PLEIN ÉCRAN (100VH) */}
      <div className="infog-hero-container">
        <div className="infog-video-wrapper">
          <video
            src={VideoPresentationInformatique}
            autoPlay
            muted
            loop
            playsInline
            className="infog-background-video"
            aria-label="Vidéo de présentation infogérance"
          />
          <div className="infog-hero-overlay"></div>
        </div>

        <div className="infog-hero-center-text">
          <h1 className="infog-title">INFOGÉRANCE & MAINTENANCE</h1>
          <p className="infog-lead">
            Nous assurons la gestion, le suivi et la performance continue de votre parc informatique.
          </p>
        </div>

        <div className="scroll-indicator" onClick={() => document.getElementById('infog-content').scrollIntoView({ behavior: 'smooth' })}>
          <span className="arrow"></span>
        </div>
      </div>

      {/* 2. TEXTE ET PILIERS SUR FOND BLANC PROPRE */}
      <div className="infog-showcase-section" id="infog-content">
        <AnimatedSection
          sectionTitle="Nos Piliers d'Accompagnement"
          direction="left"
          items={[
            { img: Update, alt: "Mises à jour et optimisation", title: "Mises à jour et optimisation", text: "Nous assurons les mises à jour logicielles pour garantir la performance et la sécurité." },
            { img: Protection, alt: "Protection", title: "Sécurité renforcée", text: "Grâce à notre supervision, nous bloquons les menaces avant qu'elles ne causent de dégâts." },
            { img: Flexibilite, alt: "Flexibilité", title: "Surveillance centralisée", text: "Une surveillance proactive garantissant fiabilité, disponibilité et protection renforcée." }
          ]}
          count={clients1}
          countLabel="Clients satisfaits"
        />

        {/* 3. SECTION DE TARIFS RESTRUCTURÉE AVEC PARAMÈTRE ICON INTERNE */}
        <div className="infog-pricing-wrapper">
          <TarifsSection
            buttonLabel="Voir nos tarifs"
            sectionTitle="Nos solutions de cybersécurité"
            tarifs={[
              { 
                title: "Pack Sentinel", 
                description: "Protection des endpoints, défense contre les menaces avancées, chiffrement complet du disque, gestion centralisée", 
                price: "7,90€ HT",
                icon: ICON_SHIELD_CHECK
              },
              { 
                title: "Vigilant", 
                description: "Sentinel + RG System : assurez la continuité de vos activités grâce à une supervision, une sauvegarde et une sécurité centralisées, simples et fiables.", 
                price: "12,90€ HT",
                icon: ICON_EYE
              },
              { 
                title: "Shield", 
                description: "Vigilant + Sauvegarde 5 Go cloud : sauvegardez vos fichiers en toute sécurité grâce à un cryptage de pointe et une double sauvegarde.", 
                price: "21,90€ HT",
                icon: ICON_CLOUD
              },
              { 
                title: "Fortress", 
                description: "Shield + EPR : l'EPR offre une sécurité avancée, détectant et bloquant les menaces les plus sophistiquées et inconnues, bien au-delà d'un simple antivirus.", 
                price: "29,90€ HT",
                icon: ICON_LOCK
              },
              { 
                title: "Fortress +", 
                description: "Fortress + Anti-SPAM", 
                price: "39,90€ HT",
                icon: ICON_ALERT
              }
            ]}
            openTarifs={openTarifs}
            setOpenTarifs={setOpenTarifs}
          />
        </div>
      </div>
    </>
  );
};

export default Infogerance;